import { combineReducers } from 'redux';
import usuarioReducer from './usuarioReducer';
import formularioReducer from './formularioReducer';
import { routerReducer } from 'react-router-redux'

export default combineReducers({
  usuario: usuarioReducer,
  formulario: formularioReducer,
  routing: routerReducer
})